import api from "../index"

const helpApi = api.injectEndpoints({
  endpoints: (build) => ({
    createHelp: build.mutation({
      query: (body) => ({
        url: `/help`,
        method: "POST",
        body,
      }),
    }),
    getHelpRequests: build.query({
      query: (params) => ({
        url: `/help/requests`,
        method: "GET",
        params,
      }),
    }),
    submitReply: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/help/reply/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    getHelpRequest: build.query({
      query: ({ id }) => ({
        url: `/help/${id}`,
        method: "GET",
      }),
    }),
    helpMarkClosed: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/help/mark/closed/${id}`,
        method: "POST",
        body: params,
      }),
    }),
  }),
})

export const {
  useCreateHelpMutation,
  useLazyGetHelpRequestsQuery,
  useSubmitReplyMutation,
  useLazyGetHelpRequestQuery,
  useHelpMarkClosedMutation,
} = helpApi
